import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core";
import t from "../common/localization";
import { useSelector } from "react-redux";
import moment from "moment";
import { useEffectAsync } from "./../reactHelper";
import Autocomplete from '@material-ui/lab/Autocomplete';


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // display: "flexEnd",
    flexDirection: "row",
    textAlign: "right",
  },
  content: {
    flex: 1,
    overflow: "auto",
    padding: theme.spacing(2),
  },
  form: {
    padding: theme.spacing(1, 2, 2),
  },
  button: {
    //  background: '#623DE6',
    border: 0,
    borderRadius: 15,
    boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
    color: "white",
    height: 35,
    margin: 3,
    marginTop: -1,
    // padding: '0 20px',
    width: 80,
    flexDirection: "row",
    primaryTextColor: 'white',
  },
  selectField: {
    textAlign: "left",
    color: 'white',
    height: "50px",
    variant: "outlined",
    margin: "5px",
    width:"30%",
  },
   selectField1: {
    textAlign: "left",
    color: 'white',
    height: "50px",
    variant: "outlined",
    margin: "5px",
    width:"23%",
  },
   selectField2: {
    textAlign: "left",
    color: 'white',
    height: "50px",
    variant: "outlined",
    margin: "5px",
    width:"37%",
  },
  overrides: {
    MuiTableRow: {
      hover: {
        backgroundColor: "green",
      },
    },
  },
  rootG: {
    "& > *": {
      margin: theme.spacing(1),
    },
    border: 0,
  },
}));
const ReplayFilter = ({ children, handleSubmit, distanceVal, showOnly }) => {
  const devices = useSelector((state) => Object.values(state.devices.items));
  const [deviceId, setDeviceId] = useState("");
  const [period, setPeriod] = useState("today");
  const [from, setFrom] = useState(moment().subtract(1, "hour"));
  const [to, setTo] = useState(moment());
  const classes = useStyles();
  const selectedId = useSelector(state => {
    if (state.devices.selectedId) {
      // setDeviceId(state.devices.selectedId);
      return state.devices.selectedId;

    }
    return null;
  });

  const handleClick = (mail, json) => {
    let selectedFrom;
    let selectedTo;
    switch (period) {
      case "today":
        selectedFrom = moment().startOf("day");
        selectedTo = moment().endOf("day");
        break;
      case "yesterday":
        selectedFrom = moment().subtract(1, "day").startOf("day");
        selectedTo = moment().subtract(1, "day").endOf("day");
        break;
      case "thisWeek":
        selectedFrom = moment().startOf("week");
        selectedTo = moment().endOf("week");
        break;
      case "previousWeek":
        selectedFrom = moment().subtract(1, "week").startOf("week");
        selectedTo = moment().subtract(1, "week").endOf("week");
        break;
      case "thisMonth":
        selectedFrom = moment().startOf("month");
        selectedTo = moment().endOf("month");
        break;
      case "previousMonth":
        selectedFrom = moment().subtract(1, "month").startOf("month");
        selectedTo = moment().subtract(1, "month").endOf("month");
        break;
      default:
        selectedFrom = from;
        selectedTo = to;
        break;
    }

    const accept = json
      ? "application/json"
      : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    handleSubmit(
      deviceId,
      selectedFrom.toISOString(),
      selectedTo.toISOString(),
      mail,
      { Accept: accept }
    );
  };

  useEffectAsync(async () => {
    setDeviceId(selectedId);
  }, []);

  return (
    <div className={classes.root}>
      <FormControl className={classes.selectField}>
        {/* <InputLabel shrink>{t('reportDevice')}</InputLabel> */}
         <Select
                  disableUnderline={true}
                  value={deviceId || ''}
                  onChange={(e) => setDeviceId(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Device
                  </MenuItem>
                  {devices.map((device) => (
                    <MenuItem value={device.id} key={device.id}>
                      {device.name}
                    </MenuItem>
                  ))}
                </Select>

      </FormControl>
      <FormControl className={classes.selectField1}>
        {/* <InputLabel>{t('reportPeriod')}</InputLabel> */}
        <Select
          inputProps={{ "aria-label": "Without label" }}
          disableUnderline={true} value={period}
          onChange={(e) => setPeriod(e.target.value)}
        >
          <MenuItem value="today">{t("reportToday")}</MenuItem>
          <MenuItem value="yesterday">{t("reportYesterday")}</MenuItem>
          <MenuItem value="thisWeek">{t("reportThisWeek")}</MenuItem>
          <MenuItem value="previousWeek">{t("reportPreviousWeek")}</MenuItem>
          <MenuItem value="thisMonth">{t("reportThisMonth")}</MenuItem>
          <MenuItem value="previousMonth">{t("reportPreviousMonth")}</MenuItem>
          <MenuItem value="custom">{t("reportCustom")}</MenuItem>
        </Select>
      </FormControl>
      {period === "custom" && (
        <TextField
          className={classes.selectField2}
          InputProps={{ "aria-label": "Without label", disableUnderline: true }}
          type="datetime-local"
          value={from.format(moment.HTML5_FMT.DATETIME_LOCAL)}
          onChange={(e) =>
            setFrom(moment(e.target.value, moment.HTML5_FMT.DATETIME_LOCAL))
          }
          fullWidth
        />
      )}
      {period === "custom" && (
        <TextField
          className={classes.selectField2}
           InputProps={{ "aria-label": "Without label", disableUnderline: true }}
          type="datetime-local"
          value={to.format(moment.HTML5_FMT.DATETIME_LOCAL)}
          onChange={(e) =>
            setTo(moment(e.target.value, moment.HTML5_FMT.DATETIME_LOCAL))
          }
          fullWidth
        />
      )}
     {period === "custom" && (
        <TextField
          className={classes.selectField2}
           InputProps={{ disableUnderline: true }}
          label={t("deviceTotalDistance")}
          type="text"
          value={distanceVal}

          fullWidth
        />
      )}
      {children}
      <FormControl className={classes.selectField} disabled={!deviceId}>
        <div className={classes.root}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleClick(false, true)}
            className={classes.button}
          >
            {t("reportShow")}
          </Button>
          {!showOnly && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClick(false, false)}
              className={classes.button}
            >
              {t("reportExport")}
            </Button>
          )}
          {!showOnly && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClick(true, false)}
              className={classes.button}
            >
              {t("reportEmail")}
            </Button>
          )}
        </div>
      </FormControl>
    </div>
  );
};

export default ReplayFilter;
